/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SubscriptionUserControllerGetStateQueryResponse,
  SubscriptionUserControllerGetState401,
} from '../../types/SubscriptionUserControllerGetState.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { subscriptionUserGetState } from '../../methods/subscriptionUserGetState.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const subscriptionUserGetStateQueryKey = () => [{ url: '/api/user/telegram/subscriptions' }] as const;

export type SubscriptionUserGetStateQueryKey = ReturnType<typeof subscriptionUserGetStateQueryKey>;

export function subscriptionUserGetStateQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = subscriptionUserGetStateQueryKey();
  return queryOptions<
    SubscriptionUserControllerGetStateQueryResponse,
    ResponseErrorConfig<SubscriptionUserControllerGetState401>,
    SubscriptionUserControllerGetStateQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return subscriptionUserGetState(config);
    },
  });
}

/**
 * {@link /api/user/telegram/subscriptions}
 */
export function useSubscriptionUserGetState<
  TData = SubscriptionUserControllerGetStateQueryResponse,
  TQueryData = SubscriptionUserControllerGetStateQueryResponse,
  TQueryKey extends QueryKey = SubscriptionUserGetStateQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        SubscriptionUserControllerGetStateQueryResponse,
        ResponseErrorConfig<SubscriptionUserControllerGetState401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? subscriptionUserGetStateQueryKey();

  const query = useQuery(
    {
      ...subscriptionUserGetStateQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<SubscriptionUserControllerGetState401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
